import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useSiteBranding from '../hooks/useSiteBranding';
import TrustSupportBanner from '../components/TrustSupportBanner';
import './TrustPages.css';

export default function ReturnPolicyPage() {
  const { siteName } = useSiteBranding();
  const brand = siteName || 'Super Wear';

  useEffect(() => {
    document.title = `Return & Refund Policy — ${brand}`;
  }, [brand]);

  return (
    <div className="trust-page">
      <div className="trust-page__inner">
        <header className="trust-page__hero">
          <p className="trust-page__hero-eyebrow">Customer care</p>
          <h1 className="trust-page__title">Return &amp; Refund Policy</h1>
          <p className="trust-page__subtitle">
            Clear rules so you can shop with confidence at {brand}.
          </p>
        </header>

        <TrustSupportBanner />

        <section className="trust-section">
          <h2>Return eligibility</h2>
          <ul>
            <li>Return requests must be raised within <strong>7 days</strong> of delivery.</li>
            <li>Items must be <strong>unused</strong>, with original tags attached where applicable.</li>
            <li>
              <strong>Original packaging</strong> (bags/boxes) should be included when returning, so we can process your
              request quickly.
            </li>
            <li>Some categories (e.g. innerwear, clearance, or personalized items) may be marked non-returnable at purchase — check the product page.</li>
          </ul>
        </section>

        <section className="trust-section">
          <h2>Condition of product</h2>
          <p>
            We can only accept returns when the product is in resalable condition: no stains, odors, alterations, or
            signs of wear. Items that fail inspection may be sent back to you or eligible for partial credit only, at our
            discretion.
          </p>
        </section>

        <section className="trust-section">
          <h2>Refund process</h2>
          <ul>
            <li>After we receive and inspect your return, approval usually takes <strong>3–7 business days</strong>.</li>
            <li>
              Refunds are issued to the <strong>original payment method</strong> where possible; for COD or other methods,
              we may offer <strong>store credit</strong> or bank transfer as agreed with support.
            </li>
            <li>Shipping charges (unless the error was ours) may be non-refundable.</li>
          </ul>
        </section>

        <section className="trust-section">
          <h2>Exchange option</h2>
          <p>
            Where stock allows, we may offer a <strong>size or color exchange</strong> instead of a refund. Exchanges
            follow the same 7-day window and condition rules.             Contact us via{' '}
            <Link to="/contact">Contact</Link> or WhatsApp with your order number.
          </p>
        </section>

        <section className="trust-section">
          <h2>How to start a return</h2>
          <p>
            Email or message us with your <strong>order number</strong> and reason for return. We will share the next
            steps (pickup or courier instructions) for addresses in Pakistan. Our support team is available{' '}
            <strong>24/7</strong> to help with returns and refunds.
          </p>
        </section>
      </div>
    </div>
  );
}
